import React from 'react';
import {
  RequirementsWrapper,
  RequirementsTitle,
  Checklist,
  GroupCard,
  GroupHeader,
  GroupTitle,
  GroupMeta,
  GroupProgressBar,
  CourseChips,
  Chip,
  Grade,
  ProgressNote,
} from './MajorRequirements.styles';

type Group = {
  title: string;
  completed: number;
  total: number;
  courses: Array<{ code: string; grade: string; muted?: boolean }>;
};

const groups: Group[] = [
  {
    title: 'Core Computer Science',
    completed: 8,
    total: 12,
    courses: [
      { code: 'CS 101', grade: 'A' },
      { code: 'CS 201', grade: 'A' },
      { code: 'CS 205', grade: 'B+', muted: true },
      { code: 'CS 301', grade: 'A-', muted: true },
    ],
  },
  {
    title: 'Mathematics',
    completed: 4,
    total: 6,
    courses: [
      { code: 'MATH 101', grade: 'A' },
      { code: 'MATH 102', grade: 'A' },
      { code: 'MATH 201', grade: 'A-' },
      { code: 'MATH 310', grade: 'B+', muted: true },
    ],
  },
  {
    title: 'General Education',
    completed: 6,
    total: 8,
    courses: [
      { code: 'ENG 101', grade: 'A' },
      { code: 'ENG 102', grade: 'A-', muted: true },
      { code: 'HIST 201', grade: 'B+' },
      { code: 'PHIL 101', grade: 'A-' },
    ],
  },
  {
    title: 'Computer Science Electives',
    completed: 2,
    total: 6,
    courses: [
      { code: 'CS 250', grade: 'A' },
      { code: 'CS 340', grade: 'A' },
      { code: 'CS 401', grade: 'A-', muted: true },
      { code: 'CS 420', grade: 'A-', muted: true },
    ],
  },
];

const MajorRequirements: React.FC = () => {
  const completed = groups.filter((g) => g.completed >= g.total).length;
  const total = groups.length;
  return (
    <RequirementsWrapper>
      <RequirementsTitle>
        <span role="img" aria-label="requirements">📋</span> Computer Science Major Requirements
      </RequirementsTitle>
      <Checklist>
        {groups.map((g) => {
          const percent = Math.round((g.completed / g.total) * 100);
          return (
            <GroupCard key={g.title}>
              <GroupHeader>
                <GroupTitle>{g.title}</GroupTitle>
                <GroupMeta>{g.completed} of {g.total} completed <span style={{ background: '#E9EEF5', color: '#223046', borderRadius: 12, padding: '2px 8px', marginLeft: 8 }}>{percent}%</span></GroupMeta>
              </GroupHeader>
              <GroupProgressBar>
                <div style={{ width: `${percent}%` }} />
              </GroupProgressBar>
              <CourseChips>
                {g.courses.map((c) => (
                  <Chip key={c.code} $muted={c.muted}>
                    <span>{c.code}</span>
                    <Grade>{c.grade}</Grade>
                  </Chip>
                ))}
              </CourseChips>
            </GroupCard>
          );
        })}
      </Checklist>
      <ProgressNote>
        {completed} of {total} requirement groups completed
      </ProgressNote>
    </RequirementsWrapper>
  );
};

export default MajorRequirements;


